// @ts-nocheck
/**
 * permalinkState.ts
 * URL状態管理・パーマリンク関連メソッド
 * App.vue から切り出し
 */

import spreadsheetSyncManager from '@/js/spreadsheetSyncManager'
import { addressFromMapCenter, japanCoord } from '@/js/downLoad'
import * as Layers from '@/js/layers'
import maplibregl from 'maplibre-gl'
import axios from 'axios'
import { VPS_API_BASE } from '@/js/phpApi'
import { scheduleSessionSave } from '@/js/sessionState'
import { restoreUserSettings as restoreUserSettingsFromAuth } from '@/js/authSetup'

type VM = any

export function updatePermalink(vm: VM) {
  if (vm.$store.state.isOffline || vm.$store.state.isNetworkOffline) {
    cancelShortUrlTimer(vm)
    return
  }
  const map = vm.$store.state.map01
  if (!map) {
    return
  }
  const center = map.getCenter()
  const zoom = map.getZoom()
  const { lng, lat } = center
  const split = vm.s_map2Flg
  const fourScreen = vm.$store.state.is4ScreenMode
  const swipe = vm.swipeMode
  const swipePosition = vm.swipePosition
  const pitch01 = vm.$store.state.map01Pitch
  const pitch02 = vm.$store.state.map02Pitch
  const bearing = vm.$store.state.map01Bearing
  let terrainLevel = vm.s_terrainLevel
  if (isNaN(terrainLevel)) terrainLevel = 1
  const terrain = vm.$store.state.isTerrainEnabled ? 1 : 0
  function removeKeys(obj, keysToRemove) {
    if (Array.isArray(obj)) {
      return obj.map(item => removeKeys(item, keysToRemove))
    } else if (typeof obj === 'object' && obj !== null) {
      const newObj = {}
      for (const [key, value] of Object.entries(obj)) {
        if (!keysToRemove.includes(key)) {
          newObj[key] = removeKeys(value, keysToRemove)
        }
      }
      return newObj
    }
    return obj
  }
  // const keysToRemove = ['label', 'source', 'layers', 'sources', 'attribution','info']
  const keysToRemove = ['source', 'layers', 'sources', 'attribution','info']
  let copiedSelectedLayers = JSON.parse(JSON.stringify(vm.$store.state.selectedLayers))
  copiedSelectedLayers = removeKeys(copiedSelectedLayers, keysToRemove)
  const selectedLayersJson = JSON.stringify(copiedSelectedLayers)
  const chibans = []
  vm.$store.state.highlightedChibans.forEach(h => {
    chibans.push(h)
  })
  const simas = []
  vm.$store.state.highlightedSimas.forEach(h => {
    simas.push(h)
  })
  const simaText = vm.$store.state.simaText
  const image = vm.$store.state.uploadedImage
  const extLayer = {layer:vm.$store.state.extLayer,name:vm.$store.state.extLayerName}
  const kmlText = vm.$store.state.kmlText
  const geojsonText = vm.$store.state.geojsonText
  const dxfText = JSON.stringify(vm.$store.state.dxfText)
  const gpxText = vm.$store.state.gpxText
  // グループ共有ドロー / プライベートドローの判定
  const isGroupDraw = (vm.$store.state.geojsonName || '').startsWith('グループ共有_')
  const isPrivateDraw = vm.$store.state.isPrivateDraw
  // プライベートドローの場合はドロー関連のGeoJSONテキストをURLに含めない
  const drawGeojsonText = isPrivateDraw ? '' : vm.$store.state.drawGeojsonText
  const clickGeojsonText = isPrivateDraw ? '' : vm.$store.state.clickGeojsonText
  // ⭐️緊急回避 マイルーム復帰のときclickCircleGeojsonTextがどこかでクリアされる現象を回避
  let clickCircleGeojsonText = vm.$store.state.clickCircleGeojsonText
  if (!clickCircleGeojsonText) {
    clickCircleGeojsonText = vm.$store.state.clickCircleGeojsonTextMyroom
    vm.$store.state.clickCircleGeojsonText = vm.$store.state.clickCircleGeojsonTextMyroom
    vm.$store.state.clickCircleGeojsonTextMyroom = ''
  }
  if (isPrivateDraw) clickCircleGeojsonText = ''
  const vector = vm.$store.state.uploadedVector
  const isWindow = vm.$store.state.isWindow
  const simaTextForUser = vm.$store.state.simaTextForUser
  const geojsinId = (isGroupDraw || isPrivateDraw) ? '' : vm.$store.state.geojsonId
  const isFromIframe = vm.$store.state.isFromIframe
  const isDrawFit = vm.$store.state.isDrawFit
  const hillshade = vm.$store.state.hillshade
  const hillshadeParam = hillshade ? encodeURIComponent(JSON.stringify(hillshade)) : ''
  // マップ連動モード
  const mapSyncMode = vm.$store.state.mapSyncMode
  // 個別モード時の各マップ座標（連動モードでないか、2画面/4画面モード時のみ記録）
  let mapStatesParam = ''
  if (!mapSyncMode && (split || fourScreen)) {
    const mapStates = {}
    const mapNames = fourScreen ? ['map01', 'map02', 'map03', 'map04'] : ['map01', 'map02']
    mapNames.forEach(mapName => {
      const m = vm.$store.state[mapName]
      if (m) {
        const c = m.getCenter()
        mapStates[mapName] = {
          lng: c.lng.toFixed(6),
          lat: c.lat.toFixed(6),
          zoom: m.getZoom().toFixed(2),
          pitch: m.getPitch().toFixed(1),
          bearing: m.getBearing().toFixed(1)
        }
      }
    })
    mapStatesParam = JSON.stringify(mapStates)
  }
  // スプレッドシート同期設定（URLを含むためエンコード必須）
  const spreadsheetSync = spreadsheetSyncManager.config ? encodeURIComponent(JSON.stringify(spreadsheetSyncManager.config)) : ''
  // 行政界履歴の座標（右ドロワーが開いていて座標がある場合のみ）
  let ghistParam = ''
  const ghistDrawer = vm.$store.state.gyoseiHistoryDrawer
  if (ghistDrawer.open && ghistDrawer.data?.coordinates) {
    const [ghistLng, ghistLat] = ghistDrawer.data.coordinates
    ghistParam = `${ghistLng.toFixed(6)},${ghistLat.toFixed(6)}`
  }
  // 断面図/3Dジオラマ状態
  const elevGeojson = vm.$store.state.elevationGeojson
  const elevMode = vm.$store.state.elevationDrawMode
  let elevGeojsonParam = '', elevModeParam = '', elev3dParam = ''
  if (elevGeojson?.features?.length > 0) {
    elevGeojsonParam = JSON.stringify(elevGeojson)
    elevModeParam = elevMode || ''
  }
  // elev3dはelevationGeojsonの有無に関わらず保存（右下ボタンからのジオラマはelevGeojsonなし）
  if (vm.$store.state.isCrossSection3D) elev3dParam = 'cs'
  else if (vm.$store.state.isDiorama3D) elev3dParam = 'dio'
  // ジオラマDEMソース（shimaneのみ記録、gsjはデフォルトなので省略）
  const diodemParam = vm.$store.state.dioramaDemSource === 'shimane' ? 'shimane' : ''
  // モノクロモード
  const mono = vm.$store.state.isSketchMode ? 1 : 0
  // ストリートビュー（ペグマン）
  const sv = vm.$store.state.streetViewFlg ? 1 : 0
  // AI物件調査レポート+ 比較ランキング状態 (Dialog が開いており 1点以上あるとき)
  // 形式: encodeURIComponent(JSON.stringify({p:[[lng,lat],...], k:'preset', w:[...]}))
  // w はカスタム重み (k='custom' のとき有効)
  let mprdParam = ''
  const mprdState = vm.$store.state.mprdShareState
  if (mprdState && Array.isArray(mprdState.points) && mprdState.points.length > 0) {
    const payload: any = {
      p: mprdState.points.map((pt: any) => [
        Number(Number(pt.lng).toFixed(6)),
        Number(Number(pt.lat).toFixed(6))
      ]),
      k: mprdState.presetKey || 'balanced'
    }
    if (mprdState.presetKey === 'custom' && mprdState.weights) {
      payload.w = [
        mprdState.weights.access,
        mprdState.weights.convenience,
        mprdState.weights.education,
        mprdState.weights.safety,
        mprdState.weights.assetValue,
        mprdState.weights.future
      ]
    }
    mprdParam = encodeURIComponent(JSON.stringify(payload))
  }
  // 3Dカメラ状態（URLボタン押下時のみ値が入る）
  let elev3dcamParam = ''
  const camState = vm.$store.state._3dCameraState
  if (camState) {
    const r = v => Number(v).toFixed(2)
    elev3dcamParam = `${r(camState.px)},${r(camState.py)},${r(camState.pz)},${r(camState.tx)},${r(camState.ty)},${r(camState.tz)},${camState.exag},${camState.mini},${camState.lod ?? 1},${camState.tex ?? 1}`
  }
  // パーマリンクの生成
  vm.param = `?lng=${lng}&lat=${lat}&zoom=${zoom}&split=${split}&fourscreen=${fourScreen}` +
    `&pitch01=${pitch01}&pitch02=${pitch02}&bearing=${bearing}&terrain=${terrain}&terrainLevel=${terrainLevel}` +
    `&slj=${encodeURIComponent(selectedLayersJson)}&chibans=${JSON.stringify(chibans)}&simas=${JSON.stringify(simas)}` +
    `&simatext=${simaText}&image=${JSON.stringify(image)}&extlayer=${JSON.stringify(extLayer)}&kmltext=${kmlText}` +
    `&geojsontext=${geojsonText}&dxftext=${dxfText}&gpxtext=${gpxText}&drawgeojsontext=${drawGeojsonText}` +
    `&clickgeojsontext=${clickGeojsonText}&clickCirclegeojsontext=${clickCircleGeojsonText}` +
    `&vector=${JSON.stringify(vector)}&iswindow=${JSON.stringify(isWindow)}&simatextforuser=${simaTextForUser}` +
    `&geojsinid=${geojsinId}&isfromiframe=${JSON.stringify(isFromIframe)}&isdrawfit=${JSON.stringify(isDrawFit)}` +
    `&hillshade=${hillshadeParam}&swipe=${JSON.stringify(swipe)}&swipepos=${swipePosition}&mapsync=${mapSyncMode}&mapstates=${mapStatesParam}&sheetsync=${spreadsheetSync}&aishare=${vm.shareFeatures.length > 0 ? encodeURIComponent(JSON.stringify(vm.shareFeatures)) : ''}&ghist=${ghistParam}&elevgeojson=${elevGeojsonParam}&elevmode=${elevModeParam}&elev3d=${elev3dParam}&elev3dcam=${elev3dcamParam}&diodem=${diodemParam}&mono=${mono}&thumbvis=${vm.$store.state.thumbnailAlwaysVisible ? 1 : 0}&sv=${sv}&mprd=${mprdParam}`
  // 地図移動時はsession_stateのみ保存（shorturl書き込みは廃止）
  // scheduleShortUrl(vm)  ← Dialog-shareからのみ使用
  scheduleSessionSave(vm)
  vm.zoom = zoom

  addressFromMapCenter()

  japanCoord([lng,lat])
}

/**
 * URL共有からの行政界履歴復元処理
 * pendingGyoseiHistoryCoordに座標がある場合、その座標で行政界履歴を表示
 * @param {maplibregl.Map} map - 地図インスタンス
 */
export function restoreGyoseiHistoryFromUrl(vm: VM, map) {
  const coord = vm.$store.state.pendingGyoseiHistoryCoord
  if (!coord) return

  // すでにドロワーが開いている場合はスキップ
  if (vm.$store.state.gyoseiHistoryDrawer.open) return

  const [lng, lat] = coord

  // pendingをクリア（一度だけ実行するため）
  vm.$store.state.pendingGyoseiHistoryCoord = null

  // 座標からピクセル位置を取得してクエリ
  const point = map.project([lng, lat])
  let features = map.queryRenderedFeatures(point, { layers: ['oh-gyosei-history-query'] })

  if (features.length === 0) {
    return
  }

  // 重複除去してSTART順にソート
  const uniqueFeatures = []
  const seenKeys = new Set()
  for (const f of features) {
    const props = f.properties
    const key = `${props.CODE5 || ''}-${props.START || ''}-${props.END || ''}`
    if (!seenKeys.has(key)) {
      seenKeys.add(key)
      uniqueFeatures.push(props)
    }
  }
  // START日付でソート（新しい順 = 現在が上）
  uniqueFeatures.sort((a, b) => (b.START || '').localeCompare(a.START || ''))

  // スライダーで選択した年の市区町村名を取得
  const selectedYear = vm.$store.state.gyoseiHistoryYear?.map01 || 2025
  const selectedDate = `${selectedYear}-01-01`
  const selectedMunicipality = uniqueFeatures.find(p =>
    (p.START || '') <= selectedDate && (p.END || '9999-12-31') > selectedDate
  ) || uniqueFeatures[0]

  // 履歴データをJSON化（AI用）
  const historyData = uniqueFeatures.slice(0, 10).map(p => ({
    name: p.NAME || '不明',
    type: p.TYPE || '?',
    start: p.START ? p.START.substring(0, 4) : '?',
    end: p.END === '2999-12-31' ? '現在' : (p.END ? p.END.substring(0, 4) : '?'),
    ken: p.KEN || '',
    gun: p.GUN || ''
  }))

  // 既存のマーカーを削除
  if (vm.$store.state.gyoseiHistoryDrawer.marker) {
    vm.$store.state.gyoseiHistoryDrawer.marker.remove()
  }

  // クリック地点にマーカーを追加
  const markerEl = document.createElement('div')
  markerEl.style.cssText = 'width:16px; height:16px; background:#FF6600; border:2px solid #fff; border-radius:50%; box-shadow:0 2px 4px rgba(0,0,0,0.3);'
  const marker = new maplibregl.Marker({ element: markerEl })
    .setLngLat([lng, lat])
    .addTo(map)

  // ドロワーを開く
  vm.$store.commit('setGyoseiHistoryDrawer', {
    open: true,
    mapName: 'map01',
    marker: marker,
    data: {
      uniqueFeatures,
      selectedMunicipality,
      selectedYear,
      historyData,
      coordinates: [lng, lat]
    }
  })

}

/**
 * パラメータ文字列から状態を復元（汎用関数）
 * @param {string} paramString - URLパラメータ文字列 (例: "lng=139&lat=35&zoom=10&...")
 */
export async function restoreFromParamString(vm: VM, paramString) {
  if (!paramString) {
    console.warn('restoreFromParamString: パラメータ文字列が空です')
    return
  }

  try {
    // パラメータをパース
    const params = new URLSearchParams(paramString)

    const lng = parseFloat(params.get('lng'))
    const lat = parseFloat(params.get('lat'))
    const zoom = parseFloat(params.get('zoom'))
    const bearing = parseFloat(params.get('bearing')) || 0
    const pitch01 = parseFloat(params.get('pitch01')) || 0
    const pitch02 = parseFloat(params.get('pitch02')) || 0
    const terrainLevel = parseFloat(params.get('terrainLevel')) || 1
    const terrain = params.get('terrain') === '1'
    const split = params.get('split')
    const fourScreen = params.get('fourscreen') === 'true'
    const swipe = params.get('swipe') === 'true'
    const swipePositionParam = parseFloat(params.get('swipepos'))
    const slj = params.get('slj')
    // マップ連動モード
    const mapSyncParam = params.get('mapsync')
    const mapStatesParam = params.get('mapstates')

    // マップ連動モードを復元
    if (mapSyncParam !== null) {
      vm.$store.state.mapSyncMode = mapSyncParam === 'true'
    }

    // マップの位置・ズーム・傾きを復元
    const map01 = vm.$store.state.map01
    const map02 = vm.$store.state.map02

    // 個別マップ座標の復元（個別モードの場合）
    if (mapSyncParam === 'false' && mapStatesParam) {
      try {
        const mapStates = JSON.parse(mapStatesParam)
        // 各マップの座標を復元
        Object.keys(mapStates).forEach(mapName => {
          const state = mapStates[mapName]
          const map = vm.$store.state[mapName]
          if (map && state) {
            map.jumpTo({
              center: [parseFloat(state.lng), parseFloat(state.lat)],
              zoom: parseFloat(state.zoom),
              pitch: parseFloat(state.pitch),
              bearing: parseFloat(state.bearing)
            })
            // storeにも保存
            vm.$store.state.mapIndividualStates[mapName] = {
              lng: parseFloat(state.lng),
              lat: parseFloat(state.lat),
              zoom: parseFloat(state.zoom),
              pitch: parseFloat(state.pitch),
              bearing: parseFloat(state.bearing)
            }
          }
        })
      } catch (e) {
        console.warn('[restoreFromParamString] mapStates parse error:', e)
      }
    } else if (map01 && lng && lat && zoom) {
      // 連動モードの場合は従来通りmap01の座標を全マップに適用
      // アニメーションなしで即座に移動
      map01.jumpTo({
        center: [lng, lat],
        zoom: zoom,
        bearing: bearing,
        pitch: pitch01
      })

      // map02が存在する場合も同様に
      if (map02 && vm.s_map2Flg) {
        map02.jumpTo({
          center: [lng, lat],
          zoom: zoom,
          bearing: bearing,
          pitch: pitch02
        })
      }
    }

    // 地形強調レベルを復元
    if (!isNaN(terrainLevel)) {
      vm.s_terrainLevel = terrainLevel
    }
    // terrain=1 の場合のみテレインを有効化
    vm.$store.state.isTerrainEnabled = terrain
    if (terrain) {
      if (map01 && map01.getSource('terrain')) {
        map01.setTerrain({ 'source': 'terrain', 'exaggeration': terrainLevel })
      }
      if (map02 && map02.getSource('terrain')) {
        map02.setTerrain({ 'source': 'terrain', 'exaggeration': terrainLevel })
      }
    } else {
      if (map01) map01.setTerrain(null)
      if (map02) map02.setTerrain(null)
    }

    // レイヤーを復元
    if (slj) {
      try {
        const selectedLayers = JSON.parse(slj)

        if (selectedLayers) {
          // layers.js から完全なレイヤー情報を再取得
          const mapNames = ['map01', 'map02', 'map03', 'map04']
          mapNames.forEach(mapName => {
            if (selectedLayers[mapName]) {
              selectedLayers[mapName].forEach(slj => {
                // レイヤーを探索して必要な情報を取得する
                const traverseLayers = (layers, slj) => {
                  if (!layers || !Array.isArray(layers)) return

                  layers.forEach(layer => {
                    if (!layer) return

                    if (layer.nodes && Array.isArray(layer.nodes)) {
                      layer.nodes.forEach(node => {
                        if (!node) return

                        if (node.nodes && Array.isArray(node.nodes)) {
                          traverseLayers([node], slj)
                        } else {
                          if (node.id === slj.id) {
                            slj.label = node.label
                            slj.source = node.source
                            slj.sources = node.sources
                            slj.layers = node.layers
                            slj.attribution = node.attribution
                            slj.info = node.info
                            // URL復元されたext.valuesを保持
                            const savedValues = slj.ext?.values
                            slj.ext = node.ext
                            if (savedValues && slj.ext) {
                              slj.ext.values = savedValues
                            }
                          }
                        }
                      })
                    } else {
                      if (layer.id === slj.id) {
                        slj.label = layer.label
                        slj.source = layer.source
                        slj.sources = layer.sources
                        slj.layers = layer.layers
                        slj.attribution = layer.attribution
                        slj.info = layer.info
                        // URL復元されたext.valuesを保持
                        const savedValues = slj.ext?.values
                        slj.ext = layer.ext
                        if (savedValues && slj.ext) {
                          slj.ext.values = savedValues
                        }
                      }
                    }
                  })
                }

                // Layers.layers[mapName] から完全な情報を取得（起動時と同じ方法）
                // map03/map04はLayers.layersに定義がないため、map01のレイヤー定義を使用
                const layerKey = (mapName === 'map03' || mapName === 'map04') ? 'map01' : mapName
                const layersForMap = Layers.layers[layerKey]
                if (layersForMap && Array.isArray(layersForMap)) {
                  traverseLayers(layersForMap, slj)
                } else {
                  console.warn(`[restoreFromParamString] Layers.layers[${layerKey}] が存在しないか配列ではありません`)
                }
              })
            }
          })

          // ブレンドレイヤーの復元処理
          mapNames.forEach(mapName => {
            if (selectedLayers[mapName]) {
              selectedLayers[mapName].forEach(slj => {
                // ブレンドレイヤーの場合、ソースとレイヤーを再生成
                if (slj.id && slj.id.startsWith('oh-blend-') && slj.blendConfig) {
                  const config = slj.blendConfig
                  const blendSourceId = `oh-blend-source-${slj.id.split('-')[2]}`

                  slj.ext = {
                    name: 'extBlend',
                    autoOpenDialog: false
                  }

                  // attributionがない場合はデフォルト値を設定
                  if (!slj.attribution) {
                    slj.attribution = `ブレンドモード: ${config.mode}`
                  }

                  slj.source = {
                    id: blendSourceId,
                    obj: {
                      type: 'raster',
                      tiles: [
                        `blend://${config.mode}/{z}/{x}/{y}.png?base=${encodeURIComponent(config.baseTiles)}&overlay=${encodeURIComponent(config.overlayTiles)}`
                      ],
                      tileSize: config.tileSize || 256
                    }
                  }

                  slj.layers = [
                    {
                      id: slj.id,
                      type: 'raster',
                      source: blendSourceId,
                      paint: {
                        'raster-opacity': 1
                      }
                    }
                  ]
                }
              })
            }
          })

          // レイヤーを復元（URLパラメータ経由の場合はext自動表示を許可）
          vm.$store.state.selectedLayers = selectedLayers
          vm.s_selectedLayers = selectedLayers

          // ブレンドレイヤーをマップに追加
          mapNames.forEach(mapName => {
            const map = vm.$store.state[mapName]
            if (!map) return

            if (selectedLayers[mapName]) {
              selectedLayers[mapName].forEach(layer => {
                // ブレンドレイヤーの場合、マップに明示的に追加
                if (layer.id && layer.id.startsWith('oh-blend-') && layer.source && layer.layers) {
                  // ソースを追加
                  if (!map.getSource(layer.source.id)) {
                    map.addSource(layer.source.id, layer.source.obj)
                  }

                  // レイヤーを追加
                  layer.layers.forEach(l => {
                    if (!map.getLayer(l.id)) {
                      map.addLayer(l)
                    }
                  })
                }

              })
            }
          })
        }
      } catch (e) {
        console.error('[restoreFromParamString] レイヤー復元エラー:', e)
      }
    } else {
      console.warn('[restoreFromParamString] slj パラメータが存在しません')
    }

    // スプレッドシート同期設定を復元
    const sheetSync = params.get('sheetsync')
    if (sheetSync) {
      try {
        const syncConfig = JSON.parse(decodeURIComponent(sheetSync))
        if (syncConfig && syncConfig.url) {
          // ローカルストレージはクリアして、URLからの設定のみ使用
          spreadsheetSyncManager.clearConfig()
          spreadsheetSyncManager.saveConfig(syncConfig)
        }
      } catch (e) {
        console.error('[restoreFromParamString] スプレッドシート同期設定の復元エラー:', e)
      }
    }

    const shouldRestoreSwipe = swipe && !vm.isSmall500

    // スワイプモードを優先的に復元
    if (shouldRestoreSwipe) {
      // スワイプには2画面が前提なので必要なら2画面化
      restoreSwipeState(vm, swipePositionParam)
    } else {
      // スワイプ指定がない場合や小画面時の処理
      if (swipe && vm.isSmall500) {
        if (!vm.s_map2Flg) {
          vm.btnClickSplit()
        }
        if (!vm.swipeBlockedNotified) {
          vm.$store.dispatch('messageDialog/open', {
            id: 'swipe-not-supported',
            title: 'スワイプ比較',
            contentHtml: '<p>小画面ではスワイプ比較を利用できません。2画面表示のみ復元しました。</p>',
            options: { icon: 'mdi-alert', iconColor: 'warning' }
          })
          vm.swipeBlockedNotified = true
        }
      } else if (fourScreen && !vm.isSmall500) {
        // 4画面モードを復元（小画面では復元しない）
        vm.setScreenMode(4)
      } else if (split === 'true' && !vm.s_map2Flg) {
        vm.btnClickSplit()
      } else if (split === 'false' && vm.s_map2Flg) {
        vm.btnClickSplit()
      } else if (!shouldRestoreSwipe && vm.swipeMode) {
        // 既にスワイプだった場合は解除
        vm.toggleSwipeMode()
      }
    }

    // モノクロモードを復元
    if (params.get('mono') === '1') {
      vm.$store.state.isSketchMode = true
      for (const name of ['map01', 'map02', 'map03', 'map04']) {
        const map = vm.$store.state[name]
        if (map) {
          const c = map.getContainer()
          if (c) c.classList.add('oh-sketch-mode')
        }
      }
    }

    // サムネイルマーカー常時表示を復元
    const thumbvisParam = params.get('thumbvis')
    if (thumbvisParam !== null) {
      vm.$store.state.thumbnailAlwaysVisible = thumbvisParam !== '0'
    }

    // ストリートビュー（ペグマン）を復元
    const svParam = params.get('sv')
    if (svParam === '1') {
      vm.$store.state.streetViewFlg = true
      localStorage.setItem('streetView', true)
      // カバレッジレイヤー表示はmap loadedイベント後にinitApp.tsが処理
    }

  } catch (error) {
    console.error('[restoreFromParamString] エラー:', error)
  }
}

/**
 * ログインユーザーのDB設定から状態を復元
 * リセット機能で使用（他人のURLで起動していても、自分の設定に戻す）
 */
export async function restoreUserSettings(vm: VM, { alertOnMissing = false } = {}) {
  return restoreUserSettingsFromAuth(vm, { alertOnMissing })
}

// パラメータ復元用：スワイプ状態を直接セット（トグルに依存しない）
export function restoreSwipeState(vm: VM, pos) {
  // 2画面必須
  if (!vm.s_map2Flg) {
    vm.btnClickSplit()
    vm.s_map2Flg = true
  }
  // map02 を同期元としてスワイプモードに入る
  vm.mapSyncMaster = 'map02'
  vm.swipeMode = true
  if (!isNaN(pos)) {
    vm.swipePosition = Math.max(0, Math.min(100, pos))
  } else {
    vm.swipePosition = 50
  }
  // スワイプ中は同期停止、map02のみ操作許可
  vm.stopMapSync()
  vm.disableSwipeFollow()
  vm.disableSwipeNudge()
  vm.disableSwipeManualPan()

  const map01 = vm.$store.state.map01
  const map02 = vm.$store.state.map02

  vm.setMapInteractions(map01, false)
  vm.setMapInteractions(map02, true)

  // 念のためズーム系インタラクションを有効化（他機能で無効化されていても復帰させる）
  ;[map01, map02].filter(Boolean).forEach(m => {
    try {
      m.scrollZoom.enable()
      m.doubleClickZoom.enable()
      m.touchZoomRotate.enable()
      if (m.touchZoomRotate && m.touchZoomRotate.disableRotation) {
        m.touchZoomRotate.disableRotation()
      }
    } catch (_) {}
  })

  // レイアウトをスワイプ用に
  vm.mapSize.map01.width = '100%'
  vm.mapSize.map01.height = '100%'
  vm.mapSize.map02.width = '100%'
  vm.mapSize.map02.height = '100%'
  vm.mapSize.map02.top = 0
  vm.mapSize.map02.right = 0
  // map02 のリサイズ & ズーム系インタラクション再有効化
  vm.$nextTick(() => {
    const map01 = vm.$store.state.map01
    const map02 = vm.$store.state.map02
    if (map02) {
      try { map02.resize() } catch (_) {}
    }
    [map01, map02].filter(Boolean).forEach(m => {
      try {
        m.scrollZoom.enable()
        m.doubleClickZoom.enable()
        m.touchZoomRotate.enable()
        if (m.touchZoomRotate && m.touchZoomRotate.disableRotation) {
          m.touchZoomRotate.disableRotation()
        }
      } catch (_) {}
    })
  })
}

export function cancelShortUrlTimer(vm: VM) {
  if (vm.$store.state.shortUrlTimerId !== null) {
    clearTimeout(vm.$store.state.shortUrlTimerId)
    vm.$store.state.shortUrlTimerId = null
  }
}

export function scheduleShortUrl(vm: VM) {
  if (vm.$store.state.isOffline || vm.$store.state.isNetworkOffline) {
    cancelShortUrlTimer(vm)
    return
  }
  const latestParam = vm.param
  if (vm.$store.state.lastShortUrlParam === latestParam) {
    cancelShortUrlTimer(vm)
    return
  }
  const delay = vm.isIphone ? 1500 : 600
  if (vm.$store.state.shortUrlTimerId !== null) {
    clearTimeout(vm.$store.state.shortUrlTimerId)
  }
  vm.$store.state.shortUrlTimerId = window.setTimeout(() => {
    vm.$store.state.shortUrlTimerId = null
    if (vm.$store.state.isOffline || vm.$store.state.isNetworkOffline) {
      return
    }
    if (vm.$store.state.lastShortUrlParam === vm.param) {
      return
    }
    createShortUrl(vm)
  }, delay)
}

export function createShortUrl(vm: VM) {
  if (vm.$store.state.isOffline || vm.$store.state.isNetworkOffline) {
    return
  }
  const currentParam = vm.param
  let params = new URLSearchParams()
  params.append('parameters', currentParam)
  axios.post(`${VPS_API_BASE}/shortUrl.php`, params)
      .then(response => {
        const urlid = response.data?.urlid
        if (!urlid) {
          console.warn('[createShortUrl] urlid が取得できませんでした:', response.data)
          return
        }
        vm.$store.state.lastShortUrlParam = currentParam
        const newUrl = window.location.pathname + "?s=" + urlid;
        window.history.pushState(null, 'map', newUrl)
        let pathName = '/'
        if (window.location.pathname !== '/') {
          pathName = window.location.pathname
        }
        vm.$store.state.url = window.location.protocol + '//' + window.location.host + pathName + "?s=" + urlid
      })
      .catch(error => {
      })
}

export async function parseUrlParams(vm: VM) {
  let params
  if (vm.dbparams) {
    params = new URLSearchParams(vm.dbparams)
  } else {
    params = new URLSearchParams(window.location.search)
    const uid = localStorage.getItem('lastUserId')

    if (uid) {
      try {
        let response = await axios.get('/oh3/php/userConfigSelect.php', {
          params: { uid: uid },
          timeout: 5000,
        });

        let starturl = ''
        if (response.data.error) {
          console.error('[起動時レイヤー] ユーザー設定取得エラー:', response.data.error);
        } else {
          starturl = response.data?.[0]?.starturl ?? '';
        }
        if (starturl) {
          response = await axios.get(`${VPS_API_BASE}/shortUrlSelect.php`, {
            params: { urlid: starturl },
            timeout: 5000,
          });
          if (response.data.error) {
            console.error('[起動時レイヤー] URL取得エラー:', response.data.error);
          } else {
            params = new URL('https://dummy/&' + response.data).searchParams
          }
        } else {
        }
      } catch (error) {
        console.error('[起動時レイヤー] 取得処理中に例外が発生しました:', error);
        console.error('[起動時レイヤー] エラー詳細:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
          uid: uid
        });
        // エラー時はデフォルトのparamsを使用（処理は継続）
      }
    }
  }
  // URL共有時の利用規約スキップフラグ
  if (params.get('skipterms') === '1') {
    vm.$store.state.skipTerms = true
  }
  const lng = parseFloat(params.get('lng'))
  const lat = parseFloat(params.get('lat'))
  const zoom = parseFloat(params.get('zoom'))
  const split = params.get('split')
  const fourScreen = params.get('fourscreen') === 'true'
  const pitch = parseFloat(params.get('pitch'))// 以前のリンクをいかすため---------------------------------
  let pitch01 = parseFloat(params.get('pitch01'))
  let pitch02 = parseFloat(params.get('pitch02'))
  if (isNaN(pitch01) && !isNaN(pitch)) pitch01 = pitch
  if (isNaN(pitch02) && !isNaN(pitch)) pitch02 = pitch
  const bearing = parseFloat(params.get('bearing'))
  const terrainLevel = parseFloat(params.get('terrainLevel'))
  const terrain = params.get('terrain') === '1'
  const sljRaw = params.get('slj')
  const slj = sljRaw ? JSON.parse(sljRaw) : null
  const chibans = params.get('chibans')
  const simas = params.get('simas')
  const simaText = params.get('simatext')
  const image = params.get('image')
  const extLayer = params.get('extlayer')
  const kmlText = params.get('kmltext')
  const geojsonText = params.get('geojsontext')
  const dxfText = params.get('dxftext')
  const gpxText = params.get('gpxtext')
  const drawGeojsonText = params.get('drawgeojsontext')
  const clickGeojsonText = params.get('clickgeojsontext')
  const clickCircleGeojsonText = params.get('clickCirclegeojsontext')
  const vector = params.get('vector')
  const isWindow = params.get('iswindow')
  const simaTextForUser = params.get('simatextforuser')
  const geojsonId = params.get('geojsinid')
  const isFromIframe = params.get('isfromiframe')
  const isDrawFit = params.get('isdrawfit')
  const hillshadeRaw = params.get('hillshade')
  let hillshade = hillshadeRaw
  if (hillshadeRaw) {
    try {
      hillshade = decodeURIComponent(hillshadeRaw)
    } catch (_) {
      hillshade = hillshadeRaw
    }
  }
  const autoReport = params.get('autoReport')
  const reportRadius = params.get('reportRadius')
  const reportLng = params.get('reportLng')
  const reportLat = params.get('reportLat')
  const swipeFlag = params.get('swipe') === 'true'
  const swipePos = params.get('swipepos')
  // マップ連動モード
  const mapSyncParam = params.get('mapsync')
  const mapStatesParam = params.get('mapstates')
  // スプレッドシート同期設定
  const sheetSync = params.get('sheetsync')
  // AI会話共有
  const aiShareId = params.get('ai')
  // AI分析マルチ地物共有
  const aiShare = params.get('aishare')
  // AI物件調査レポート+ 比較ランキング復元用 JSON (encodeURIComponent + JSON)
  // 形式: {"p":[[lng,lat],...], "k":"family", "w":[1,2,3,4,5,6]}
  // k=プリセットキー, w=カスタム重み (省略可)
  const mprdShare = params.get('mprd')
  // 行政界履歴の座標
  const ghist = params.get('ghist')
  // 断面図/3Dジオラマ復元
  const elevGeojsonRaw = params.get('elevgeojson')
  const elevMode = params.get('elevmode')
  const elev3d = params.get('elev3d')
  const elev3dcam = params.get('elev3dcam')
  const diodem = params.get('diodem') || ''
  // モノクロモード
  const mono = params.get('mono') === '1'
  // サムネイルマーカー常時表示
  const thumbvisRaw = params.get('thumbvis')
  const thumbvis = thumbvisRaw !== null ? thumbvisRaw !== '0' : true // デフォルトtrue
  // ストリートビュー（ペグマン）
  const sv = params.get('sv') === '1'

  vm.pitch.map01 = pitch01
  vm.pitch.map02 = pitch02
  vm.bearing = bearing
  vm.s_terrainLevel = terrainLevel

  // 起動時のパラメータ文字列を保存（初回のみ）
  if (!vm.$store.state.initialParamString) {
    vm.$store.state.initialParamString = params.toString()
  }

  // URLパラメータ解析完了フラグ（TermsAgreementDialogのタイミング制御用）
  vm.$store.state.urlParamsReady = true

  return {
    lng,lat,zoom,split,fourScreen,pitch,pitch01,pitch02,bearing,terrain,terrainLevel,slj,
    chibans,simas,simaText,image,extLayer,kmlText,geojsonText,dxfText,gpxText,
    drawGeojsonText,clickGeojsonText,clickCircleGeojsonText,vector,isWindow,
    simaTextForUser,geojsonId,isFromIframe,isDrawFit,hillshade,autoReport,reportRadius,reportLng,reportLat,
    swipeFlag,swipePos,mapSyncParam,mapStatesParam,sheetSync,aiShareId,aiShare,mprdShare,ghist,
    elevGeojsonRaw,elevMode,elev3d,elev3dcam,diodem,mono,thumbvis,sv
  }// 以前のリンクをいかすためpitchを入れている。
}

